module.exports = __webpack_public_path__ + "img/pageinteriors_individuos-y-familias-05vida-y-ahorro.ed4a1b11.jpg";